<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">聚宝盆</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>存币记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select v-model="coinType" placeholder="请选择币种">
          <el-option value>请选择</el-option>
          <el-option
            v-for="item in projects"
            :key="item.coinType"
            :label="item.coinType"
            :value="item.coinType"
          ></el-option>
        </el-select>
        <el-input placeholder="请输入用户ID" v-model="userId"></el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';

export default {
  name: 'lockrecod',
  data() {
    return {
      coinType: '',
      userId: ''
    };
  },
  components: {
    List
  },
  computed: {
    ...mapState('lockrecod', ['pagination']),
    ...mapState('cornucopia', ['projects'])
  },
  methods: {
    ...mapActions('lockrecod', ['getRecords']),
    handleSearch() {
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      const params = {};
      if (this.coinType) {
        params.coinType = this.coinType;
      }
      if (this.userId) {
        params.userId = this.userId;
      }
      this.getRecords({
        ...params,
        ...this.pagination,
        ...data
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
